export const ADMIN = 'ADMIN';
export const DELIVERY = 'DELIVERY'
